<template>
  <div>
    <!--menubar-->
    <navigator @doFold="onedoFold2" :isZ="isZ"></navigator>
    <router-view :key="$route.fullPath" class="mt-16" :class='[unfold ? "pl80" : "pl312"]' :unfold="unfold" @doFold="onedoFold" @openPj="oneOpenPj"></router-view>
    <v-footer color="#dcdcdc" :class='[unfold ? "pl80" : "pl312"]' padless style="position:fixed; bottom:0px; width:100%; z-index:10;">
      <v-card elevation="0" class="text-center font-weight-bold" tile height="48px" color="lava" style="width:100% !important;" v-if="!isAuthed" @click="authModal=true">
        <p class="pt-3 mx-auto" style="color: white; font-size: 16px;">現在ログインしていません。ここをタッチして、参加しましょう！</p>
      </v-card>
      <v-system-bar class="text-center font-weight-bold" color="lava" height="48px" style="width:100% !important;" v-else-if="aboutLid&&!(aboutLid.sanka)">
        <p class="mb-0 mx-auto" style="color: white; font-size: 16px;">現在この{{ $t('Lid') }}に参加していません。<v-btn class="py-0 font-weight-bold" text style="text-decoration: underline; font-size: 16px; color:#FF9E40;" @click="LidSankaAlert=true">参加</v-btn>しますか?</p>
      </v-system-bar>
      <div class="py-0 text-center" v-if="config && config.inquiry" style="width: 100%;">
        <p class="mb-0">お問い合わせ：<span v-text="config.inquiry"></span></p>
        <a v-if="config && config.inquiryUrl" :href="config.inquiryUrl" target="_blank" rel="noopener">{{ config.inquiryUrl }}</a>
      </div>
      <v-card-text class="py-0 text-center">
        <span>&copy;</span> {{ new Date().getFullYear() }} — <strong>Liquitous</strong>
      </v-card-text>
    </v-footer>

    <!--サインイン画面-->
    <v-dialog v-model="authModal" width="400px" height="60%">
      <auth-view
        defaultView="chooseauth"
        @closeModal="closeAuthModal"
      >
      </auth-view>
    </v-dialog>

    <v-dialog v-model="card_lidsanka" width="600px">
      <v-card class="pa-2 d-flex flex-column" height="200px">
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn icon @click="card_lidsanka=false">
            <v-icon color="#E64550">mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
        <v-card-text class="text-center ink--text my-auto" style="font-size:25px;">{{ $t('Lid') }}に参加しました</v-card-text>
        <v-card-actions class="mt-auto">
          <v-spacer></v-spacer>
          <v-chip class="deepAqua white--text" @click="card_lidsanka=false">確認</v-chip>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--Lid参加確認画面-->
    <v-dialog v-model="LidSankaAlert" width="800">
      <v-card color="white" elevation="15" class="pt-6">
        <v-card-actions class="d-flex justify-center align-center">
          <div>
            <p class="font-weight-bold text-h5 text-center">あなたはこの{{ $t('Lid') }}に参加していません。</p>
            <p class="font-weight-bold text-h5 text-center mb-0">この{{ $t('Lid') }}に参加しますか？</p>        
          </div>
        </v-card-actions>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-chip class="ma-4 pa-4" @click="LidSankaAlert = false" >参加しない</v-chip>
          <v-chip class="ma-4 pa-4" @click="LidSankaAlert = false, $store.dispatch('inLid',{lidId:$route.params.id,uid:uid}), card_lidsanka = true" color="deepAqua" dark>参加</v-chip>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import firebase from "firebase/app"
import "firebase/firestore"
import authView from '../../components/auth/authView.vue';
import navigator from '../../components/navigator.vue'
import VueMq from 'vue-mq'
Vue.use(VueMq, {
  breakpoints: { // default breakpoints - customize this
    sp: 959,
    pc: 960
  },
  defaultBreakpoint: 'pc' // customize this for SSR
})
  export default {
    components: {
      navigator,
      authView
    },
    data: () => ({
      unfold: false,
      authModal: false,
      card_lidsanka:false,
      LidSankaAlert:false,
      isZ: false
    }),
    computed:{
      uid() {
        return this.$store.state.auth?.user?.uid || '';
      },
      isAuthed() {
        return this.$store.state.auth?.isAuthed;
      },
      config(){
        return this.$store.state.config
      },
      lid(){
        return this.$store.state.lid
      },
      alid(){
        return this.$store.state.alid
      },
      aboutLid() {
        if (this.$store.state.lid.some((u) => u.id === this.$route.params.id)) {
          return this.$store.state.lid.filter((u) => u.id === this.$route.params.id)[0]
        } else if (this.$store.state.alid.some((u) => u.id === this.$route.params.id)) {
          return this.$store.state.alid.filter((u) => u.id === this.$route.params.id)[0]
        } else {
          return null
        }
      },
    },
    created() {
    },
    mounted(){
      if(this.$mq === 'sp'){
        this.$router.replace({path: '/sp/'+this.$route.path.split('/').slice(2).join('/'), query: this.$route.query})
      }
    },
    methods: {
      onedoFold(el){
        //console.log("unfold:",el)
        this.unfold = el
      },
      closeAuthModal() {
        this.authModal = false
      },
      onedoFold2(el){
        this.unfold = el
      },
      oneOpenPj(el){
        this.isZ=el
      },
    }
  }
</script>
<style scoped>
.pl312{
  padding-left:312px !important;
}
.pl80{
  padding-left:160px !important;
}
</style>
